module.exports = __webpack_public_path__ + "img/p1.9a39ada3.png";